<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
  @if (label(); as label) {
    <mat-label
      role="link"
      [routerLink]="routerLink()"
      [class.cursor-pointer]="!!routerLink()"
      [class.text-primary-400]="!!routerLink()"
      (click)="$event.stopPropagation(); $event.preventDefault()"
    >
      {{ label }}
      @if (routerLink()) {
        <mat-icon>open_in_new</mat-icon>
      }
    </mat-label>
  }
  <input
    type="text"
    placeholder="Kies"
    aria-label="Number"
    matInput
    #input
    [formControl]="formControl"
    (input)="setInputValue($event)"
    (focus)="setInputValue($event)"
    [matAutocomplete]="auto"
    (blur)="handleBlur()"
  />
  @if (isAdminPortal() && formControl.value) {
    <mat-icon
      matIconSuffix
      (click)="input.value = ''; cleared.set(true)"
      class="cursor-pointer"
    >
      cached
    </mat-icon>
  }
  <mat-autocomplete
    requireSelection
    #auto="matAutocomplete"
    (closed)="closed()"
    (optionSelected)="selected()"
    [displayWith]="displayWith()"
    [panelWidth]="_panelWidth()"
  >
    @for (item of items(); track item) {
      <mat-option [value]="item">
        <span class="!whitespace-pre">
          {{ displayWith() | apply: item }}
        </span>
      </mat-option>
    } @empty {
      @if (loading()) {
        <mat-option class="pointer-events-none">Loading</mat-option>
      } @else {
        <mat-option class="pointer-events-none">No results</mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
